import { createSelector } from '@reduxjs/toolkit';
import { SelectItem, stringToSelectItem } from 'vet-bones/utils/select';

import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { namedGraphsByModelSelector } from 'src/selectors/namedGraphsByModel';
import { ReduxState } from 'src/store/types';
import { DEFAULT_MODEL } from 'src/templates/queries/iris';

export type ModelSelectItem = SelectItem & {
  namedGraphIris: string[];
};

const defaultModelItems: ModelSelectItem[] = [
  {
    ...stringToSelectItem(DEFAULT_MODEL),
    namedGraphIris: [],
  },
];

export const modelItemsSelector = memoizeSelectorFactory((databaseId: string) =>
  createSelector(
    (state: ReduxState) =>
      databaseId
        ? state.databases.databasesById?.[databaseId]?.models || []
        : [],
    namedGraphsByModelSelector(databaseId),
    (modelNames, namedGraphsByModel): ModelSelectItem[] => {
      return modelNames?.length
        ? modelNames.map((modelName) => ({
            ...stringToSelectItem(modelName),
            namedGraphIris: namedGraphsByModel?.[modelName] || [],
          }))
        : defaultModelItems;
    }
  )
);
